


function queryToObject(query) {
    // Create a URLSearchParams instance from the query.
    const params = new URLSearchParams(query);
    // Convert the entries iterator to an object.
    return Object.fromEntries(params.entries());
}

module.exports = queryToObject;
